import { render, staticRenderFns } from "./area-add.vue?vue&type=template&id=69d51e13&scoped=true&"
import script from "./area-add.vue?vue&type=script&lang=js&"
export * from "./area-add.vue?vue&type=script&lang=js&"
import style0 from "./area-add.vue?vue&type=style&index=0&id=69d51e13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d51e13",
  null
  
)

export default component.exports